import { createApiSlice } from 'app/createApiSlice'

export const payableNotesApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'catatan/utang',

  endpoints(builder) {
    return {
      postPayable: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/payable/manual`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      postPayablePersonal: builder.mutation({
        query(payload) {
          return {
            url: `/api/v1/bussines/personal-payable-manual`,
            method: 'POST',
            body: payload,
          }
        },
      }),
      postPayPayable: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/payable/pay-manual`,
            method: 'POST',
            body,
          }
        },
      }),
      postPayPayablePersonal: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/personal-payable-pay-manual`,
            method: 'POST',
            body,
          }
        },
      }),
      mergeReceiveable: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/receiveable/merge`,
            method: 'POST',
            body,
          }
        },
      }),
      mergeReceiveablePersonal: builder.mutation({
        query(body) {
          return {
            url: `/api/v1/bussines/personal-receiveable-merge`,
            method: 'POST',
            body,
          }
        },
      }),
      postCategory: builder.mutation({
        query({ label, type }) {
          return {
            url: `/api/v1/bussines/payable/category`,
            method: 'POST',
            body: {
              label,
              incomeorexpense: type,
            },
          }
        },
      }),
      postCategoryPersonal: builder.mutation({
        query({ label, type }) {
          return {
            url: `/api/v1/bussines/personal-payable-category`,
            method: 'POST',
            body: {
              label,
              incomeorexpense: type,
            },
          }
        },
      }),
      deleteCategory: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/bussines/payable-category`,
            method: 'DELETE',
            params: { id },
          }
        },
      }),
      deleteCategoryPersonal: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/bussines/personal-payable-category`,
            method: 'DELETE',
            params: { id },
          }
        },
      }),
      editCategory: builder.mutation({
        query({ id, label }) {
          return {
            url: `/api/v1/bussines/payable-category`,
            method: 'PATCH',
            params: { id },
            body: {
              label,
            },
          }
        },
      }),
      editCategoryPersonal: builder.mutation({
        query({ id, label }) {
          return {
            url: `/api/v1/bussines/personal-payable-category`,
            method: 'PATCH',
            params: { id },
            body: {
              label,
            },
          }
        },
      }),
      getPayable: builder.query({
        query({
          type,
          size,
          page,
          search,
          sortby,
          sortdir,
          status,
          counterparty,
          from,
          to,
          projectId,
          categoryId,
        }) {
          return {
            url: `/api/v1/bussines/payable`,
            params: {
              type,
              size,
              page,
              search,
              sortby: sortdir,
              sortDir: sortby,
              status,
              counterparty,
              from,
              to,
              projectId,
              categoryId,
            },
          }
        },
      }),
      getPayablePersonal: builder.query({
        query({
          type,
          size,
          page,
          search,
          sortby,
          sortdir,
          status,
          counterparty,
          from,
          to,
          projectId,
          categoryId,
        }) {
          return {
            url: `/api/v1/bussines/personal-payable`,
            params: {
              type,
              size,
              page,
              search,
              sortby: sortdir,
              sortDir: sortby,
              status,
              counterparty,
              from,
              to,
              projectId,
              categoryId,
            },
          }
        },
      }),
      getCategories: builder.query({
        query({ active, userId, type }) {
          return {
            url: `/api/v1/bussines/payable-category`,
            params: { type, active, userId },
          }
        },
      }),
      getCategoriesPersonal: builder.query({
        query({ active, userId, type }) {
          return {
            url: `/api/v1/bussines/personal-payable-category`,
            params: { type, active, userId },
          }
        },
      }),
      getPayableDetail: builder.query({
        query({ id }) {
          return {
            url: `/api/v1/bussines/payable/${id}`,
          }
        },
      }),
      checkPhoneNumberPayable: builder.query({
        query({ search, type = 'ARAP' }) {
          return {
            url: '/api/v1/bussines/transaction/checkuser',
            params: {
              search,
              type,
            },
          }
        },
      }),
      getRelations: builder.query({
        query({ userId, s, isAgent = 0 }) {
          return {
            url: `/api/v1/bussines/payable/relations`,
            params: {
              userId,
              s,
              isAgent,
            },
          }
        },
      }),
      findAgents: builder.query({
        query({ s }) {
          return {
            url: `/api/v1/bussines/search-agent`,
            params: {
              s,
            },
          }
        },
      }),
      deleteRelation: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/bussines/payable/relations/${id}`,
            method: 'DELETE',
          }
        },
      }),
      editRelation: builder.mutation({
        query({ relationName, relationPhoneNumber, id }) {
          return {
            url: `/api/v1/bussines/payable/relations/${id}`,
            method: 'PATCH',
            body: {
              relationName,
              relationPhoneNumber,
            },
          }
        },
      }),
      getPendingPayable: builder.query({
        query() {
          return {
            url: `/api/v1/bussines/payable/pending`,
          }
        },
      }),
      getPendingPayablePersonal: builder.query({
        query() {
          return {
            url: `/api/v1/bussines/personal-payable-pending`,
          }
        },
      }),
      approvePending: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/bussines/payable/accept/${id}`,
            method: 'POST',
          }
        },
      }),
      approvePendingPersonal: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/bussines/personal-payable-accept/${id}`,
            method: 'POST',
          }
        },
      }),
      rejectPending: builder.mutation({
        query({ id }) {
          return {
            url: `api/v1/bussines/payable/reject/${id}`,
            method: 'POST',
          }
        },
      }),
      rejectPendingPersonal: builder.mutation({
        query({ id }) {
          return {
            url: `api/v1/bussines/personal-payable-reject/${id}`,
            method: 'POST',
          }
        },
      }),
      getPaymentHistory: builder.query({
        query({
          type,
          size,
          page,
          search,
          sortby,
          sortdir,
          from,
          to,
          paymentmethod,
          projectId,
        }) {
          return {
            url: `/api/v1/bussines/payable/payment-history`,
            params: {
              type,
              size,
              page,
              search,
              sortby: sortdir,
              sortdir: sortby,
              paymentmethod,
              from,
              to,
              projectId,
            },
          }
        },
      }),
      getPaymentHistoryPersonal: builder.query({
        query({
          type,
          size,
          page,
          search,
          sortby,
          sortdir,
          from,
          to,
          paymentmethod,
          projectId,
        }) {
          return {
            url: `/api/v1/bussines/personal-payable-payment-history`,
            params: {
              type,
              size,
              page,
              search,
              sortby: sortdir,
              sortdir: sortby,
              paymentmethod,
              from,
              to,
              projectId,
            },
          }
        },
      }),
      downloadInvoicePayable: builder.mutation({
        query({ id }) {
          return {
            url: `/api/v1/payable/download-invoice/${id}`,
            method: 'GET',
            responseHandler: (response) => response.blob(),
          }
        },
      }),

    }
  },
})

export const {
  usePostPayableMutation,
  usePostPayablePersonalMutation,
  usePostPayPayableMutation,
  usePostPayPayablePersonalMutation,
  useEditCategoryMutation,
  useEditCategoryPersonalMutation,
  usePostCategoryMutation,
  usePostCategoryPersonalMutation,
  useDeleteCategoryMutation,
  useDeleteCategoryPersonalMutation,
  useGetPayableQuery,
  useGetPayablePersonalQuery,
  useGetCategoriesQuery,
  useGetCategoriesPersonalQuery,
  useGetPayableDetailQuery,
  useGetPayableDetailPersonalQuery,
  useLazyGetPayableQuery,
  useLazyGetPayablePersonalQuery,
  useLazyGetCategoriesQuery,
  useLazyGetCategoriesPersonalQuery,
  useCheckPhoneNumberPayableQuery,
  useLazyCheckPhoneNumberPayableQuery,
  useGetRelationsQuery,
  useLazyGetRelationsQuery,
  useFindAgentsQuery,
  useLazyFindAgentsQuery,
  useDeleteRelationMutation,
  useEditRelationMutation,
  useGetPendingPayableQuery,
  useGetPendingPersonalQuery,
  useApprovePendingMutation,
  useApprovePendingPersonalMutation,
  useRejectPendingMutation,
  useRejectPendingPersonalMutation,
  useGetPaymentHistoryQuery,
  useGetPaymentHistoryPersonalQuery,
  useMergeReceiveableMutation,
  useMergeReceiveablePersonalMutation,
  useDownloadInvoicePayableMutation,
} = payableNotesApiSlice
